import { Type } from 'class-transformer'
import { BaseEntity, type Searchable } from './base'
import { DeadlineType } from './deadline-type'
import type { RecordTool } from './record-tool'
import { AssignedRecordType, BaseAssignedRecordType, NewAssignedRecordType } from './record-type'

export class NewPracticeType {
  displayName!: string
  judicial!: boolean
  icon?: string
  externalIdLabel?: string | null
  defaultPhaseName!: string
  defaultPhaseColor!: string
}

export class UpdatePracticeType {
  displayName?: string
  icon?: string
  externalIdLabel?: string | null
}

export class UpdatePracticePhase {
  displayName?: string
  color?: string
  visible?: boolean
  default?: boolean
  archiving?: boolean
}

export class NewPracticePhase {
  displayName!: string
  color!: string
  visible!: boolean
  default!: boolean
  archiving!: boolean
}

export class PracticeTypeRow extends BaseEntity implements Searchable {
  displayName!: string
  judicial!: boolean
  icon!: string
  externalIdLabel!: string | null

  public get searchString() {
    return this.displayName
  }
}

export class PracticeType extends PracticeTypeRow {
  recordTools!: RecordTool[]
  assignmentRoles!: string[]
}

export class PracticePhase extends BaseEntity implements Searchable {
  displayName!: string
  default!: boolean
  visible!: boolean
  color!: string
  archiving!: boolean
  practiceTypeId!: string

  public get searchString() {
    return this.displayName
  }
}

export class PracticeTypeComplete extends PracticeType {
  @Type(() => PracticePhase)
  practicePhases!: PracticePhase[]

  @Type(() => DeadlineType)
  deadlineTypes!: DeadlineType[]
}

export interface GetAllPracticeTypes {
  practiceTypes: PracticeTypeRow[]
}

export interface GetAllPracticePhases {
  practicePhases: PracticePhase[]
}

export interface PracticeTypeCreated {
  practiceType: BaseEntity
}
export interface PracticeTypeUpdated {
  practiceType: PracticeType
}
export interface GetPracticeType {
  practiceType: PracticeTypeComplete
}

export class NewRecordTool {
  recordToolKey!: string
  autoRun!: boolean
}

export class NewAssignmentRole {
  roleName!: string
}

export class NewPracticeRecordType extends NewAssignedRecordType {}

export class BasePracticeRecordType extends BaseAssignedRecordType {
  practiceTypeId!: string
}

export class PracticeRecordType extends AssignedRecordType {
  practiceTypeId!: string
}

export interface GetPracticeRecordTypes {
  practiceRecordTypes: PracticeRecordType[]
}
export interface PracticeRecordTypeWritten {
  practiceRecordType: BasePracticeRecordType
}
